import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class CorpNewsList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        yearsConData: PropTypes.string,
    };

    constructor(props) {
        super(props);

        const { content } = this.props;

        this.state = {
            // 默认展示2019年的 大事记内容
            contentData: content.newList2020,
        };
    }

    componentDidMount() {
        this.createChannelInfo();
    }

    componentDidUpdate(prevProps) {
        if (this.props.yearsConData !== prevProps.yearsConData) {
            this.createChannelInfo();
        }
    }

    createChannelInfo = () => {
        const { content, yearsConData } = this.props;

        if (yearsConData === '255939') {
            this.setState({
                contentData: content.newList2019,
            });
        } else if (yearsConData === '255940') {
            this.setState({
                contentData: content.newList2018,
            });
        } else if (yearsConData === '255941') {
            this.setState({
                contentData: content.newList2017,
            });
        } else if (yearsConData === '255942') {
            this.setState({
                contentData: content.newList2016,
            });
        } else if (yearsConData === '255943') {
            this.setState({
                contentData: content.newList2015,
            });
        } else if (yearsConData === '225822') {
            this.setState({
                contentData: content.newList2014,
            });
        } else if (yearsConData === '225823') {
            this.setState({
                contentData: content.newList2013,
            });
        } else if (yearsConData === '255944') {
            this.setState({
                contentData: content.newList2012,
            });
        } else if (yearsConData === '255945') {
            this.setState({
                contentData: content.newList2011,
            });
        } else if (yearsConData === '255946') {
            this.setState({
                contentData: content.newList2010,
            });
        } else if (yearsConData === '195915') {
            this.setState({
                contentData: content.newList2009,
            });
        } else if (yearsConData === '225824') {
            this.setState({
                contentData: content.newList2008,
            });
        } else if (yearsConData === '255947') {
            this.setState({
                contentData: content.newList2007,
            });
        } else if (yearsConData === '195916') {
            this.setState({
                contentData: content.newList2006,
            });
        } else if (yearsConData === '255948') {
            this.setState({
                contentData: content.newListAgo,
            });
        } else if (yearsConData === '285132') {
            this.setState({
                contentData: content.newList2020,
            });
        } else if (yearsConData === '285147') {
            this.setState({
                contentData: content.newList2021,
            });
        }
    };

    render() {
        return (
            <div className={styles.recorLinks}>
                <ul className={styles.linksUl}>
                    {this.state.contentData.map((item, index) => {
                        return (
                            <li key={index}>
                                <a href={item.url} title={index}>
                                    {item.title}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}

export default CorpNewsList;
